<template>
    <div>
        <div>
            <gift-cards
                class="mt-12"
                :request-options="requestOptions"
            />
        </div>
    </div>
</template>
<script>
import GiftCards from "./GiftCards";

export default {
    components: {
        GiftCards
    },
    props: {
        requestOptions: {
            type: Object,
            required: false,
            default: () => {}
        }
    }
}
</script>
